"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  _createClass(Form, [{
    key: "render",
    value: function render() {
      // figure out the child we should show
      var child = this.props.children({
        getValue: this._getValue,
        setValue: this._updateValue,
        getError: this._getErrors,
        data: _extends({}, this.state.data),
        hasErrors: this._hasErrors,
        clear: this._clear
      }); // if the child is not a valid element

      if (!React.isValidElement(child)) {
        // yell loudly
        throw new Error('Child of Form must return a valid react element.');
      }

      return child;
    } // A field counts as having been updated if it had initial data

  }, {
    key: "_resetStates",
    value: function _resetStates(resetData) {
      var initialData = resetData || this.props.initialData || this.props.value || {};
      return {
        _updated: {},
        data: _extends({}, initialData),
        // we could start off with errors
        errors: _lodash.default.mapValues(this.props.validate, // if the validator doesn't like empty strings
        function (validator, key) {
          return validator(initialData[key] || '', initialData);
        })
      };
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var newValue = nextProps.value,
          newInitialData = nextProps.initialData;
      var _props = this.props,
          oldValue = _props.value,
          oldInitialData = _props.initialData; // if we were given a new value or initial data

      if (newInitialData && this._didValueUpdate(newInitialData, oldInitialData)) {
        this._clear(newInitialData);
      } // value have the last say


      if (newValue && this._didValueUpdate(newValue, oldValue)) {
        // update the internal tracker
        this._updateValue(newValue);
      }
    }
  }, {
    key: "_hasErrors",
    get: function get() {
      return Object.values(this.state.errors).filter(function (err) {
        return Array.isArray(err) ? err.length > 0 : err;
      }).length > 0;
    }
  }]);

  function Form(props) {
    var _ref;

    var _this;

    _classCallCheck(this, Form);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this, props].concat(args)));

    _this._isUpdated = function (key) {
      return _this.state._updated[key] || _this.props.initialData && _this.props.initialData[key] !== null && typeof _this.props.initialData[key] !== 'undefined';
    };

    _this._updateValue = function (newValues) {
      // the state after updating the value
      var state = _extends({}, _this.state); // for each value we want to change


      var _arr = Object.keys(newValues);

      for (var _i = 0; _i < _arr.length; _i++) {
        var _key2 = _arr[_i];

        // grab the transform if it exists
        var _transform = _this.props.transform[_key2] || function (str) {
          return str;
        }; // and apply it to the new value and update the key to the value


        state.data[_key2] = _transform(newValues[_key2]);
        state._updated = _extends({}, state._updated, _defineProperty({}, _key2, true));
      } // Run validation over all the fields if one exists for the field


      var _arr2 = Object.keys(_this.props.validate);

      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var _key3 = _arr2[_i2];
        // Pass the updated and transformed value onto the validator and store the error result
        // Also pass all of the current values if the validator needs to validate based on other values
        state.errors[_key3] = _this.props.validate[_key3](state.data[_key3], state.data);
      } // update the component state


      _this.setState(state, function () {
        // if we have an onchange handler to call
        if (_this.props.onChange) {
          // pass the form data to the handler
          _this.props.onChange(_this.state.data);
        }
      });
    };

    _this._getValue = function (key) {
      return _this.state.data[key];
    };

    _this._getErrors = function (key) {
      // if we aren't supposed to calculate initial errors and we haven't been updated
      if (!_this.props.initialErrors && !_this._isUpdated(key)) {
        // return the empty error value
        return null;
      }

      return _this.state.errors[key] || null;
    };

    _this._clear = function (resetData) {
      _this.setState(_this._resetStates(resetData));
    };

    _this._didValueUpdate = function (newValue, oldValue) {
      return newValue && !oldValue || JSON.stringify(newValue) !== JSON.stringify(oldValue);
    };

    _this.state = _this._resetStates();
    return _this;
  }

  return Form;
}(React.Component);

Form.defaultProps = {
  validate: {},
  transform: {},
  initialErrors: false
};
var _default = Form;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/state/Form/index.js
// module id = ./node_modules/quark-core/components/state/Form/index.js
// module chunks = 0